import { Modal } from 'antd';
import React from 'react';

import BaseModal from '@/components/CartPage/AddressesModal/BaseModal';
import { montserrat } from '@/components/Layout';

import { Address } from '@/utils/interfaces/Manage-Addresses';

interface Props {
  open: boolean;
  onCancel?:
    | ((e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
  onOk?:
    | ((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
  addresses: Address[] | undefined;
  onSelect?: (e: Address) => void;
  selectedAddress?: Address | null;
  onClickCreate?: () => void;
  onClickEdit?: (address: Address) => void;
}

const AddressesModal: React.FC<Props> = ({
  open,
  onCancel,
  onOk,
  addresses,
  onSelect,
  selectedAddress,
  onClickCreate,
  onClickEdit,
}) => {
  return (
    <Modal
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      footer={false}
      centered
      closeIcon={false}
      classNames={{
        content: 'bg-cardBg p-0 rounded-[12px]',
      }}
      style={{
        fontFamily: montserrat.style.fontFamily,
      }}
    >
      <BaseModal
        varient="modal"
        onCancel={onCancel}
        addresses={addresses}
        onSelect={onSelect}
        selectedAddress={selectedAddress}
        onClickCreate={onClickCreate}
        onClickEdit={onClickEdit}
      />
    </Modal>
  );
};

export default AddressesModal;
